var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.layout,{tag:"component"},[_c('router-view'),_c('error-message',{attrs:{"shouldShow":true,"options":_vm.errorMessageOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }